import { render, staticRenderFns } from "./chartScale.vue?vue&type=template&id=3e504f22&scoped=true&lang=pug&"
import script from "./chartScale.vue?vue&type=script&lang=js&"
export * from "./chartScale.vue?vue&type=script&lang=js&"
import style0 from "./chartScale.vue?vue&type=style&index=0&id=3e504f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e504f22",
  null
  
)

export default component.exports